<template>
  <!-- TODO titleMobileButtonVisibilityBeacon -->
  <div :aria-hidden="!isMobile" class="mt-8 md:hidden">
    <!-- @FIXME is the flex class needed? -->
    <div class="flex">
      <ContainerProductTitles />
    </div>

    <ContainerRatingInfo class="mb-8" />

    <PopularityStatsSalesCaption
      v-if="popularityStatsResponse && popularityStatsResponse[0]"
      :popularity-stats-sales="popularityStatsResponse[0]"
    />
  </div>

  <div class="my-16 flex flex-row items-center">
    <div class="grow">
      <JPContainerPrice />
    </div>

    <ContainerAddToCart
      class="mood-tangaroa"
      data-id="product-page-buy-button-mobile"
      data-qa="product-page-buy-button-mobile"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'

import ContainerAddToCart from '~/scopes/product-core/components/containers/ContainerAddToCart/ContainerAddToCart.vue'
import ContainerRatingInfo from '~/scopes/product-core/components/containers/ContainerProductSummary/components/ContainerRatingInfo/ContainerRatingInfo.vue'
import ContainerProductTitles from '~/scopes/product-core/components/containers/ContainerProductTitles/ContainerProductTitles.vue'
import { useFetchPopularityStatsSales } from '~/scopes/product-core/composables/useFetch/useFetchPopularityStatsSales/useFetchPopularityStatsSales'
import JPContainerPrice from '~/scopes/product-core/pages/ProductDetailPage/jp/components/JPContainerPrice/JPContainerPrice.vue'
import PopularityStatsSalesCaption from '~/scopes/product-core/pages/ProductDetailPage/jp/components/presentationals/PopularityStatsSalesCaption/PopularityStatsSalesCaption.vue'

const { data: popularityStatsResponse } = useFetchPopularityStatsSales()

// @FIXME: potential hydration mismatch caused by client-only breakpoint detection
const breakpoint = useClientOnlyComputedBreakpoint()
const isMobile = computed(() => breakpoint.value < Breakpoint.MD)
</script>
